function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M43 45c-.55 0-1-.45-1-1v-7H8v7c0 .55-.45 1-1 1s-1-.45-1-1v-8c0-.55.45-1 1-1h36c.55 0 1 .45 1 1v8c0 .55-.45 1-1 1z",
  fill: "#fff"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M43 43H7c-.55 0-1-.45-1-1s.45-1 1-1h36c.55 0 1 .45 1 1s-.45 1-1 1zm0-6c-.39 0-.75-.23-.91-.59l-8-18a1 1 0 01.51-1.32c.51-.23 1.09 0 1.32.51L42 31.29V30c0-.55.45-1 1-1s1 .45 1 1v6c0 .47-.33.88-.79.98-.07.01-.14.02-.21.02zM7 37c-.07 0-.14-.01-.21-.02-.46-.1-.79-.51-.79-.98v-6c0-.55.45-1 1-1s1 .45 1 1v1.29l6.09-13.69c.16-.37.51-.6.91-.6h3c.55 0 1 .45 1 1s-.45 1-1 1h-2.35L7.91 36.41c-.16.36-.52.59-.91.59z",
  fill: "#fff"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M35 19h-3c-.55 0-1-.45-1-1s.45-1 1-1h2v-7c0-1.65-1.35-3-3-3H19c-1.65 0-3 1.35-3 3v8c0 .55-.45 1-1 1s-1-.45-1-1v-8c0-2.76 2.24-5 5-5h12c2.76 0 5 2.24 5 5v8c0 .55-.45 1-1 1z",
  fill: "#fff"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.73 23h-9.47c-.86 0-1.68-.37-2.25-1.01-.57-.65-.83-1.5-.73-2.36l.5-4A3.01 3.01 0 0120.76 13h8.47a3.01 3.01 0 012.98 2.63l.5 4c.11.85-.16 1.71-.73 2.36-.57.64-1.39 1.01-2.25 1.01zm-8.96-8c-.5 0-.93.38-.99.88l-.5 4c-.04.29.05.57.24.79.19.22.46.34.75.34h9.47c.29 0 .56-.12.75-.34.19-.22.28-.5.24-.79l-.5-4c-.06-.5-.49-.88-.99-.88h-8.47z",
  fill: "#fff"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 50 50"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/accommodation.a9fc1197.svg";
export { SvgComponent as ReactComponent };